import { render, staticRenderFns } from "./CobroFacturas.vue?vue&type=template&id=53e83482&"
import script from "./CobroFacturas.vue?vue&type=script&lang=js&"
export * from "./CobroFacturas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports